module.exports = __webpack_public_path__ + "img/fatal-error.7bed4afd.png";